"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNeverDef = void 0;
function parseNeverDef() {
    return {
        not: {},
    };
}
exports.parseNeverDef = parseNeverDef;
